import { render, staticRenderFns } from "./IncidentField.vue?vue&type=template&id=2239e3a8&scoped=true"
import script from "./IncidentField.vue?vue&type=script&lang=js"
export * from "./IncidentField.vue?vue&type=script&lang=js"
import style0 from "./IncidentField.vue?vue&type=style&index=0&id=2239e3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2239e3a8",
  null
  
)

export default component.exports